import { render } from "./ATASummaryReport.vue?vue&type=template&id=a0a74d1a"
import script from "./ATASummaryReport.vue?vue&type=script&lang=js"
export * from "./ATASummaryReport.vue?vue&type=script&lang=js"

import "./ATASummaryReport.vue?vue&type=style&index=0&id=a0a74d1a&lang=css"

import exportComponent from "/var/www/tis-live/frontend/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__